/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Button, Segment, Table } from "semantic-ui-react";
import { Checkbox } from '@mui/material';
import { selectCurrentUserApiToken, selectCurrentUserId } from "../slices/currentUser/currentUserSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../slices/footer/footerSlice";
import { fetchSavedSearches, savedSearchUpdated, selectAllSavedSearches, selectSavedSearchesStatus } from "../slices/savedSearches/savedSearchesSlice";
import { changeSearchSettings } from "../slices/searchSettings/searchSettingsSlice";

const runSavedSearch = (savedSearch, dispatch, navigate) => {
    dispatch(changeSearchSettings(savedSearch));
    let body = JSON.parse(JSON.stringify(savedSearch));
    body.updateLastRan = true;
    dispatch(savedSearchUpdated(body));
    if (savedSearch.source === "fevir") {
        navigate('/search');
    } else if (savedSearch.source === "medline") {
        navigate('/medlineconvert');
    } else if (savedSearch.source === "ctgov") {
        navigate('/ctgovconvert');
    } else {
        alert("Running this saved search query is not yet supported.");
    }
}

// eslint-disable-next-line no-empty-pattern
const SavedSearchesSection = ({ }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const savedSearches = useSelector(state => selectAllSavedSearches(state));
    const savedSearchesStatus = useSelector(state => selectSavedSearchesStatus(state));

    useEffect(() => {
        if (apiToken) {
            dispatch(fetchSavedSearches());
        }
    }, [apiToken]);

    return <div>
        {savedSearchesStatus === "succeeded" &&
            <div>
                {savedSearches.length === 0 ?
                    <h3>You haven't saved any searches yet.</h3>
                    :
                    <>
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Label</Table.HeaderCell>
                                    <Table.HeaderCell>Source</Table.HeaderCell>
                                    <Table.HeaderCell>Search String</Table.HeaderCell>
                                    <Table.HeaderCell>Parameters</Table.HeaderCell>
                                    <Table.HeaderCell>Date Last Run</Table.HeaderCell>
                                    <Table.HeaderCell>Actions</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {savedSearches.map((savedSearch, index) => {
                                    return <Table.Row key={index}>
                                        <Table.Cell><b>{savedSearch.label}</b></Table.Cell>
                                        <Table.Cell>{savedSearch.source}</Table.Cell>
                                        <Table.Cell><i>{savedSearch.searchstring}</i></Table.Cell>
                                        <Table.Cell style={{ wordBreak: "break-word" }}>{savedSearch.searchparameters && JSON.stringify(savedSearch.searchparameters)}</Table.Cell>
                                        <Table.Cell>
                                            {savedSearch.lastcheckeddate}
                                            <br />
                                            <Checkbox style={{ padding: "0px 0px 4px 0px" }}
                                                checked={savedSearch.autocheck} size="small" color="primary"
                                                onClick={(e) => {
                                                    let body = JSON.parse(JSON.stringify(savedSearch));
                                                    body.autocheck = e.target.checked;
                                                    dispatch(savedSearchUpdated(body));
                                                }}
                                            /> Automatically check
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Button className="formButton positive" content="Search" compact
                                                onClick={() => {
                                                    runSavedSearch(savedSearch, dispatch, navigate);
                                                }} />
                                            <br /><br />
                                            <Button className="formButton negative" content="Delete" compact
                                                onClick={async () => {
                                                    let body = JSON.parse(JSON.stringify(savedSearch));
                                                    body.removed = true;
                                                    dispatch(savedSearchUpdated(body));
                                                }} /></Table.Cell>
                                    </Table.Row>;
                                })}
                            </Table.Body>
                        </Table>
                    </>
                }
            </div>
        }
    </div>;
};

// eslint-disable-next-line no-empty-pattern
const SavedSearchesPage = ({ }) => {
    const dispatch = useDispatch();
    const userId = useSelector(selectCurrentUserId);
    const isLoggedIn = (!!userId && userId !== "1");

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR Saved Searches"));
    }, []);

    return <div>
        <Segment className={`containerSegment remainderOfPageSegment`} raised>
            <>{!isLoggedIn ?
                <h1>Please login to view your saved searches.</h1>
                :
                <SavedSearchesSection />
            }</>
        </Segment>
    </div>;
};
export default SavedSearchesPage;
export { SavedSearchesSection };